// extracted by mini-css-extract-plugin
export default {"noCoversations":"HomeMessages_noCoversations__-PTYh","notification":"HomeMessages_notification__G9YCB"};